import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"

const TimeOffNotFound = ({ type, colSpan }) => {
  const { t } = useTranslation()

  return (
    <tbody>
      <tr>
        <td colSpan={colSpan}>
          <Text className="w-full text-center block">{t("calendar.schedule_time_off.time_off_not_found", { type })}</Text>
        </td>
      </tr>
    </tbody>
  )
}

TimeOffNotFound.propTypes = {
  type: PropTypes.string,
  colSpan: PropTypes.number
}

export default TimeOffNotFound
